import { getSurvey2dsByProjectId } from '@core/core/store'
import {
  addPolygonNotification,
  addSurvey2dFileUploadErrorNotification,
} from '@notifications/actions'
import { createAsyncThunk } from '@reduxjs/toolkit'
import type { ProjectId } from 'common/types'

import {
  continueUploadSurvey2dApi,
  getAllGridHeadersByProjectIdApi,
  uploadFaultApi,
  uploadHorizonApi,
  uploadMapApi,
  uploadPolygonsApi,
  uploadSurvey2dApi,
} from '../../api'
import type {
  ContinueUploadSurvey2dType,
  UploadFaultType,
  UploadHorizonType,
  UploadMapType,
  UploadSurvey2dType,
} from '../../types'
import { addMaps } from '../maps'
import { addMapToProject } from '../project'
import type { AppDispatch } from '../store'
import { uploadsSlice } from './uploadsSlice'

export const { addUploadFiles } = uploadsSlice.actions

export const uploadHorizonFiles = createAsyncThunk(
  'UploadHorizons',
  ({ projectId, data }: { projectId: ProjectId; data: UploadHorizonType }) => {
    uploadHorizonApi(projectId, data)
  },
)

export const uploadPolygonsFiles = createAsyncThunk<
  Promise<void>,
  { projectId: ProjectId; files: File[] },
  { dispatch: AppDispatch }
>('UploadSurvey2d', async ({ projectId, files }) => {
  const polygonsUploadResult = await uploadPolygonsApi(projectId, files)
  polygonsUploadResult.forEach(addPolygonNotification)
})

export const uploadFaultFiles = createAsyncThunk<
  Promise<void>,
  { projectId: ProjectId; data: UploadFaultType },
  { dispatch: AppDispatch }
>('UploadFault', ({ projectId, data }) => uploadFaultApi(projectId, data))

export const uploadSurvey2dFiles = createAsyncThunk<
  Promise<void>,
  { data: UploadSurvey2dType },
  { dispatch: AppDispatch }
>('UploadSurvey2d', async ({ data }) => {
  const projectId = data.projectId
  if (projectId) {
    try {
      await uploadSurvey2dApi(data)
    } catch (err: unknown) {
      addSurvey2dFileUploadErrorNotification(err)
    }
  }
})

export const continueUploadSurvey2dFiles = createAsyncThunk<
  Promise<void>,
  { projectId: ProjectId; data: ContinueUploadSurvey2dType },
  { dispatch: AppDispatch }
>('ContinueUploadSurvey2d', async ({ projectId, data }, { dispatch }) => {
  await continueUploadSurvey2dApi(data)
  dispatch(getSurvey2dsByProjectId(projectId))
})

export const uploadMapFiles = createAsyncThunk(
  'UploadMap',
  async ({ projectId, data }: { projectId: ProjectId; data: UploadMapType[] }, thunkAPI) => {
    const maps = await uploadMapApi(projectId, data)
    const dispatch = thunkAPI.dispatch
    dispatch(addMaps(maps))

    const newMaps = await getAllGridHeadersByProjectIdApi(projectId)
    dispatch(addMaps(newMaps))
    dispatch(addMapToProject(newMaps))
  },
)
